import { useMemo } from "react";
import type { Target } from "@/utils/types/flavor";
import type { Variant, VariantStats } from "@/utils/types/variant";
import { computeCurrent } from "@/utils/formulation/computeCurrent";
import { computeLoss } from "@/utils/formulation/computeLoss";

/**
 * Per-variant statistics for the tabs popover. Loss is computed locally
 * from each variant's formulation; cost requires supplier supply-flags
 * which are only fetched for the ACTIVE flask, so non-active variants
 * receive `cost: null`. The active variant's cost is computed at the
 * WorkbenchPage level and replaces this `null` at the consumer.
 */
export function useFormulationStats(
  variants: Variant[],
  target: Target | null | undefined
): Record<string, VariantStats> {
  return useMemo(() => {
    const map: Record<string, VariantStats> = {};
    for (const v of variants) {
      const cur = computeCurrent(v.formulation, target);
      map[v.id] = { loss: computeLoss(cur, target), cost: null };
    }
    return map;
  }, [variants, target]);
}
